<script lang="ts">
	import { TalksHeader } from '#lib/websites/talks/components/TalksHeader/index.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<TalksHeader>
	{@render children?.()}
</TalksHeader>
